import { format } from "date-fns";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { templatesSelector } from "../../../redux/templateSlice";

const TemplateList = ({ selected, onSelect }) => {
  const templates = useSelector(templatesSelector);

  return (
    <ul>
      {templates.data &&
        templates.data.map((item) => (
          <li
            key={item.id}
            className={selected?.id === item.id ? "active" : ""}
            onClick={() => onSelect(item)}
          >
            <Link to="#" className="mediaTemplate">
              <h3>{item.name}</h3>
              <p>Survey Template</p>
              <ul>
                <li>
                  <span className="badge-primary">
                    Created:{" "}
                    {item.createdOn &&
                      format(new Date(item.createdOn), "MMM dd, yyyy")}
                  </span>
                </li>
                {/* <li>
                  <span className="badge-warning">In use</span>
                </li> */}
              </ul>
            </Link>
          </li>
        ))}
    </ul>
  );
};

export default TemplateList;
